import { RESPONSE_SCHEMA_TYPE } from "./types";
import type { SldcMessage, SldcMessages } from "./types";

export const getCurrentSdlcMessages = (
  sdlcMessagesHistory: Array<SldcMessages>,
) => {
  // It should never be undefined.
  // Guaranteed by initialState and no way to remove messages
  return sdlcMessagesHistory.at(-1) as SldcMessages;
};

export const getLastSdlcMessage = (
  sdlcMessagesHistory: Array<SldcMessages>,
) => {
  return sdlcMessagesHistory.at(-1)?.at(-1);
};

/**
 * In-place increment of the action count on the last SDLC implement message
 * Useful to use with Immer.
 * @param sdlcMessagesHistory - The history of SDLC messages
 */
export const incrementActionCountOnLastImplementSdlcMessage = (
  sdlcMessagesHistory: Array<SldcMessages>,
) => {
  const currentSdlcMessages = getCurrentSdlcMessages(sdlcMessagesHistory);

  // 1. Find the latest SDLC implement message index
  const reversedIndex = currentSdlcMessages
    .slice() // clone
    .reverse()
    .findIndex(
      (message) => message.type === RESPONSE_SCHEMA_TYPE.SDLC_IMPLEMENT_EVENT,
    );

  if (reversedIndex === -1) {
    return;
  }

  // 2. Get the message from the original array
  const index = -reversedIndex - 1;
  const lastImplementSdlcMessage = currentSdlcMessages.at(index) as Extract<
    SldcMessage,
    { type: RESPONSE_SCHEMA_TYPE.SDLC_IMPLEMENT_EVENT }
  >;

  // 3. Update that message in-place
  if (lastImplementSdlcMessage) {
    lastImplementSdlcMessage.actionsCount += 1;
  }
};
